import { z } from 'zod';
import { fieldsToValidate, validateField } from '../helper';
import { IdentificationType } from '../types';
import { baseResidentialApplicant, identification, photoId } from './model';

export const baseIdentification = z.object({
  identification: identification.superRefine((val, ctx) => {
    validateField(val, ctx, val.type, fieldsToValidate[val.type]);
  }),
});

export const baseIdentificationWithoutMedicare = z.object({
  identification: identification
    .merge(z.object({ type: z.enum([IdentificationType.DRIVING_LICENSE, IdentificationType.PASSPORT]) }))
    .superRefine((val, ctx) => {
      validateField(val, ctx, val.type, fieldsToValidate[val.type]);
    }),
});

export const applicantWithIdentification = baseResidentialApplicant
  .pick({
    firstName: true,
    middleName: true,
    lastName: true,
    address: true,
    type: true,
    dateOfBirth: true,
  })
  .merge(baseIdentification);

export const baseIdentificationWithPhotoId = z.object({
  identification: identification
    .merge(
      z.object({
        photoId: photoId.optional(),
      }),
    )
    .superRefine((val, ctx) => {
      validateField(val, ctx, val.type, fieldsToValidate[val.type]);
    }),
});

export const applicantWithPhotoIdentification = applicantWithIdentification.merge(baseIdentificationWithPhotoId);

export const applicantWithNoMedicareIdentification = applicantWithIdentification.merge(
  baseIdentificationWithoutMedicare,
);
